/**
 * Enum Trạng thái tài sản cố định
 * ndquang1 30/06/2023
 */
export default {
  // Không chọn
  NotChoose: 0,

  // / Đã mua nhưng chưa dùng (Chưa tính hao mòn)
  BoughtNotUsed: 1,

  // / Đang dùng và tính hao mòn
  Using: 2,

  // / Ngưng tính hao mòn
  StopDepreciation: 3,

  // / Đã thanh lý, nhượng bán
  Saled: 4,
};
